// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"3b5dad74","815":"a7f4e462"}[chunkId] + ".chunk.js";
};